import type { Ref } from "vue"
import type { IBonusNotification } from "../shared/types/User.type"
import { storeToRefs } from "pinia"
import { onMounted, ref, watch } from "vue"
import { useBetStore } from "../../../store"
import { markNotificationAsRead } from "../api"

export function useBonusNotification() {
  const store = useBetStore()
  const { showNotificationsBonusModal, getShowNotificationsBonusModal } = storeToRefs(store)

  const newBonusNotification: Ref<IBonusNotification | null> = ref(findNewBonusNotification(store.getNotifications))

  function findNewBonusNotification(notifications: IBonusNotification[]): IBonusNotification | null {
    return notifications?.find(
      notification => notification.status === "new" && notification.type === "bonus",
    ) || null
  }

  async function handleModalVisibility(isVisible: boolean) {
    if (!isVisible || !newBonusNotification.value)
      return

    try {
      await markNotificationAsRead(newBonusNotification.value.id)
    }
    catch (error) {
      console.error("Failed to mark notification as read:", error)
    }
  }

  function handleNotificationsUpdate(notifications: IBonusNotification[]) {
    if (getShowNotificationsBonusModal.value)
      return

    newBonusNotification.value = findNewBonusNotification(notifications)
    store.setShowNotificationsBonusModal(!!newBonusNotification.value)
  }

  onMounted(() => {
    store.setShowNotificationsBonusModal(!!newBonusNotification.value)
  })

  watch(() => store.getNotifications, handleNotificationsUpdate, { immediate: true })
  watch(getShowNotificationsBonusModal, handleModalVisibility)

  function closeModal() {
    store.setShowNotificationsBonusModal(false)
    store.setShowBonusModal(true)
  }

  return {
    newBonusNotification,
    showNotificationsBonusModal,
    closeModal,
  }
}
